import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetClientUser } from '~/hooks';

type Args = {
  userId: number;
};

/**
 * 利用者詳細ヘッダーコンポーネント専用フック
 * 利用者名を取得して返す
 */
export const useUserDetailHeader = ({ userId }: Args) => {
  const { data } = useGetClientUser({
    threeLetterCode: getThreeLetterCode() || '',
    id: userId,
  });
  return { fullName: data.user.full_name };
};
